import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { caProvinces } from '../data';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const endor: OrganizationSettings = {
  name: 'Endor Health',
  replyToEmail: 'no-reply@notify.portals.care',
  mainStripeOrg: 'jack_health',
  ecommerceEnabled: true,
  stripeEnabled: true,
  defaultPauseCollection: true, // this is used when creating orders in the EMR when no pauseCollection property passed in the request
  emrEnabled: true,
  currency: 'cad',
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  patientPortalDomain: 'endor.portals.care',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By booking you agree to our&nbsp;
    <a
    href="javascript:window.open('https://policies.google.com/privacy?hl=en-US', 'popup', 'width=600,height=600');"
    >
    This is my custom Demo clinic policies
    </a>
    </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'Endor Health',
    // logo: 'https://i0.wp.com/www.writefromscratch.com/wp-content/uploads/2018/12/demo-logo.png?ssl=1',
    emrPatientLink: 'https://emr.portals.care/customers/',
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Segments',
            link: CRM_WEB_PAGES_URLS.segment.list,
            icon: 'fa-solid fa-table-columns'
          },
          {
            title: 'Recurring Tasks',
            link: CRM_WEB_PAGES_URLS.recurringTasks.list,
            icon: 'fas fa-recycle'
          },
          // {
          //   title: 'Schemas',
          //   link: CRM_WEB_PAGES_URLS.crmSchemas.list,
          //   icon: 'fas fa-receipt',
          //   roles: ['developer']
          // },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette',
            roles: ['admin', 'developer']
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'Endor Health',
    defaultPingMsg:
      '🛎️ Ping! Endor Health team is waiting for your response. To respond, please go to https://endor.portals.care/messages',
    questionnaires: ['facesheet', 'ids', 'endor_intake'],
    mainMenu: [
      // {
      //   title: 'Appointments',
      //   link: ADMIN_WEB_PAGES_URLS.appointments.calendar,
      //   icon: 'fas fa-calendar-check',
      //   roles: ['*']
      // },
      // {
      //   title: 'Queue',
      //   link: ADMIN_WEB_PAGES_URLS.encounter.current,
      //   icon: 'fas fa-calendar-check',
      //   roles: ['*']
      // },
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Consultations',
        name: 'consultations',
        link: ADMIN_WEB_PAGES_URLS.consultations.onlineList,
        icon: 'fas fa-user-md',
        roles: ['*']
      },
      // {
      //   title: 'RX Transfers',
      //   name: 'rx-transfers',
      //   link: ADMIN_WEB_PAGES_URLS.consultations.generalList,
      //   icon: 'fas fa-file-prescription',
      //   roles: ['pharmacy', 'admin', 'owner']
      // },
      {
        title: 'Orders',
        name: 'orders',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['*']
      },
      // {
      //   title: 'Orders Kanban',
      //   name: 'orders-kanban',
      //   link: ADMIN_WEB_PAGES_URLS.orders.kanban,
      //   icon: 'fas fa-cart-plus',
      //   roles: ['*']
      // },
      {
        title: 'Tasks',
        link: ADMIN_WEB_PAGES_URLS.tasks.list,
        icon: 'fas fa-list-check',
        roles: ['*']
      },
      {
        title: 'Drugs',
        link: ADMIN_WEB_PAGES_URLS.drugs.allList,
        icon: 'fas fa-pills',
        roles: ['*']
      },
      {
        title: 'RXs',
        name: 'rxs',
        link: ADMIN_WEB_PAGES_URLS.prescriptions.allList,
        icon: 'fas fa-prescription',
        roles: ['pharmacy', 'admin', 'owner']
      }
    ]
  },
  patientWebAppLayout: {
    title: 'Endor Health',
    brand: 'endorhealth',
    topAction: {
      title: 'Book Now',
      link: 'https://www.appgen.studio/book-appointment-demo'
    },
    logo: {
      img: 'https://uploads-ssl.webflow.com/64c93eafed962a0e3b78e374/65f3630ec5de910674bddb06_Endor_forgotpass.png',
      link: 'https://www.endorhealth.com/'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://endor.portals.care/auth/signup',
      referralFAQ: 'https://endorhealth.com/referral-rewards/'
    },
    shopUrl: 'https://www.endorhealth.com/',
    privacyPolicyUrl: 'https://policies.google.com/privacy?hl=en-US',
    termsOfUseUrl: 'https://policies.google.com/privacy?hl=en-US',
    stripePublicKey:
      // 'pk_test_51JcjAfKeCoUxIkZxqifwsMKca7GgkWZHB9cQoJC5zrRbk7bxtFCpC1jEkK37r8Fmk8W9xhy7RsjtchX03z1xZoOK00EgXYoj08',
      'pk_live_xgW4U7GvVtnOACnuHkaTQ6jF007oxkvEUs',
    mainMenu: [
      {
        title: 'Profile',
        link: PATIENT_WEB_PAGES_URLS.account.profile,
        svg: 'assets/icons/profile.svg',
        roles: ['*']
      },
      {
        title: 'Orders',
        link: PATIENT_WEB_PAGES_URLS.account.orders,
        svg: 'assets/icons/orders.svg',
        roles: ['*']
      },
      {
        title: 'Prescriptions',
        link: PATIENT_WEB_PAGES_URLS.account.prescriptions,
        svg: 'assets/icons/rxs.svg',
        roles: ['*']
      }
    ],
    availableStates: {
      ca: [...caProvinces]
    }
  }
};
